import "@/App.css";
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import LandingPage from "@/pages/LandingPage";
import BuyersPage from "@/pages/BuyersPage";
import InstitutionalPage from "@/pages/InstitutionalPage";
import FarmhousesPage from "@/pages/FarmhousesPage";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const prevPath = useRef(null);
  useEffect(() => {
    const pathChanged = prevPath.current !== pathname;
    prevPath.current = pathname;
    if (hash) {
      // deep link (e.g. /#owners) — idempotent; StrictMode-safe (second run wins)
      let attempts = 0;
      let timer;
      const tryScroll = () => {
        const el = document.querySelector(hash);
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
          else el.scrollIntoView();
        } else if (attempts++ < 30) {
          timer = window.setTimeout(tryScroll, 50);
        }
      };
      tryScroll();
      return () => window.clearTimeout(timer);
    }
    if (pathChanged) {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }
    return undefined;
  }, [pathname, hash]);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
      return undefined;
    const lenis = new Lenis({ anchors: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/buyers" element={<BuyersPage />} />
          <Route path="/institutional" element={<InstitutionalPage />} />
          <Route path="/farmhouses" element={<FarmhousesPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
